import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Nav, NavItem, NavLink, Row } from 'reactstrap';

// Componentes
import MainCard from '../../../../../components/MainCard';
import PermissoesUsuario from './PermissoesUsuario';
import Identificacao from './Identificacao';
import EtapasFiscalizacao from './EtapasFiscalizacao';

//Helpers
import { showMessage } from '../../../../../helpers/message';

//Context
import { useAuth } from '../../../../../context/auth';

//API
import usuario_api from '../../../../../api/usuario_api';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

function initialStateUsuario() {
    return {
        nome: "",
        status: "Ativo",
        email: "",
        perfil_Id: "",
        registroFuncional: "",
        realizaFiscalizacao: "Não",
        regionais: [],
        tipoFiscalizacoes: []
    }
}

function UsuarioStepper({ id = null, handleVoltar, editavel = false }) {
    const { setLoading } = useAuth();

    //State de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    //State para criar / editar
    const [usuario, setUsuario] = useState(initialStateUsuario());

    //State para guarda as fiscalizações de etapas
    const [listFiscalizacaoEtapas, setListFiscalizacaoEtapas] = useState([]);

    async function loadFiscalizacaoEtapas(){
        try {
            const { data } = await roteiroDeFiscalizacao_api.GetAllFiscalizacaoEtapas();
            setListFiscalizacaoEtapas(data || []);
        } catch (e) {
            showMessage("Erro", e.message, "error", null);
        } finally {
            setLoading(false);
        }
    }

    async function loadUsuarioItem(id) {
        if (id != null || usuario?.id != null) {
            setLoading(true);
            try {
                const { data } = await usuario_api.getItem(usuario?.id ?? id); 

                data.realizaFiscalizacao = data.realizaFiscalizacao ? "Sim" : "Não";
                data.perfil_Id = data.perfil_Id.toString();

                setUsuario(data);
            } catch (e) {
                showMessage("Erro", e.message, "error", null);
            } finally {
                setLoading(false);
            }
        }
    }



    useEffect(() => {
        loadUsuarioItem(id);
        loadFiscalizacaoEtapas();
    }, []);


    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    usuario={usuario}
                    setUsuario={setUsuario}
                    loadUsuarioItem={loadUsuarioItem}
                    editavel={editavel}
                />
            case 2:
                return <PermissoesUsuario
                    usuario={usuario}
                    setUsuario={setUsuario}
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                />
            case 3:
                return <EtapasFiscalizacao
                    usuario={usuario} 
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                    listFiscalizacaoEtapas={listFiscalizacaoEtapas}
                />
            default:
                return <></>;
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <h4 style={{ color: "#666" }}>Usuários</h4>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Dados de Identificação
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!usuario.id) {
                                showMessage("Aviso", "Salve a identificação do usuário para preencher as permissões de acesso", "info", null);
                                return;
                            }

                            setActiveStep(2);
                        }}
                    >
                        Permissões de Acesso
                    </NavLink>
                </NavItem>
                 <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 3 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 3 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!usuario.id) {
                                showMessage("Aviso", "Salve a identificação do usuário para preencher as permissões de acesso", "info", null);
                                return;
                            }

                            setActiveStep(3);
                        }}
                    >
                        Etapas de Fiscalização
                    </NavLink> 
                </NavItem>
            </Nav>
            <div className="mt-4">
                {getContent()}
            </div>
        </MainCard>
    </>;
}

export default UsuarioStepper;